export default {
    namespaced: true,
    state: {
        vehicles: null,
        vehicle: null,
        searchVehicles: []
    },
    mutations: {
        setVehicles: (state, vehicles) => {
            state.vehicles = vehicles;
        },

        setVehicle: (state, vehicle) => {
            state.vehicle = vehicle;
        },

        setSearchVehicles: (state, vehicles) => {
            if(vehicles.length) {
                state.searchVehicles = vehicles;
            }
            else {
                state.searchVehicles = [];
            }
        }
    },
    actions: {
        getVehicles(context, params) {
            return this.$axios.get('/vehicles', {params: params})
                .then(response => {
                    if(response.data.data.vehicles) {
                        context.commit('setVehicles', response.data.data.vehicles);
                    }

                    return response;
                });
        },

        getVehicle(context, id) {
            return this.$axios.get('/vehicle/' + id)
                .then(response => {
                    if(response.data.vehicle) {
                        context.commit('setVehicle', response.data.vehicle);
                    }

                    return response;
                });
        },

        getSearchVehicles({commit}, params) {
            if(!params.search.length) {
                commit('setSearchVehicles', []);
                return;
            }

            return this.$axios.post('/vehicles/autocompleteVehicle', { plateNo: params.search, type: params.type })
                .then(response => {
                    if(response.data.vehicles) {
                        commit('setSearchVehicles', response.data.vehicles);
                    }

                    return response;
                });
        },

        clearSearchVehicles({commit}) {
            commit('setSearchVehicles', []);
        },

        updateVehicle(context, data) {
            return this.$axios.put('/vehicle/' + data.id, data)
                .then(response => {
                    return response;
                });
        },

        deleteVehicle(context, id) {
            return this.$axios.delete('/vehicle/' + id)
                .then(response => {
                    return response;
                });
        },

        addVehicle(context, data) {
            return this.$axios.post('/vehicles', data)
                .then(response => {
                    return response;
                });
        }
    },
    getters: {
        getVehicles: (state) => {
            return state.vehicles;
        },

        getVehicle: (state) => {
            return state.vehicle;
        },

        getSearchVehicles: ({ searchVehicles }) => {
            return searchVehicles;
        }
    }
}
